<template>
    <div class="checkbox-wrapper text-[14px]">
        <div class="flex">
            <div class="checkbox-container relative mr-4">
                <input @click="isChecked = !isChecked" v-model="isChecked" :id="id" :name="name" type="checkbox" :class="['icon-check', disabled ? '' : 'cursor-pointer', 'checked:bg-deep-blue/30']" :disabled="disabled" />
            </div>
            <div class="basis-5/6 mb-4" v-if="label">
                <label class="label" v-if="label" :for="id" v-html="label"></label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CheckboxComponent",
    props: {
        name: { type: String, default: "" }, // "Name" prop for naming the input
        id: { type: String, default: "" }, // "id" prop for naming the input
        value: { default: "" }, // "Value" prop for setting an initial value for the input
        label: { type: String, default: "" }, // Label used for the input
        disabled: { type: Boolean, default: true }, // Is the checkbox disabled
    },
    components: {

    },
    computed: {},
    data: function () {
        return {
            isChecked: this.value
        };
    },
    watch: {
		isChecked(value) {
			this.isChecked = !!value;
			this.$emit('input', this.isChecked);
            this.$emit('change', this.isChecked);
		},
        value(value) {
			this.isChecked = !!value;
		}
	}
};
</script>
